import { render, staticRenderFns } from "./BulkBlockNumbers.vue?vue&type=template&id=6b1503a6&scoped=true"
import script from "./BulkBlockNumbers.vue?vue&type=script&lang=js"
export * from "./BulkBlockNumbers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b1503a6",
  null
  
)

export default component.exports